/* XXLplant PDP v3: pot + aantal koppelen aan de hoofdknop, panelen openen. */
(function () {
  const fmt = (cents) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'nl', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100); }
    catch (e) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  };
  const t = (k, fb) => (window.xxlPdpI18n && window.xxlPdpI18n[k]) || fb;

  function init() {
    const form = document.querySelector('.product__info-wrapper form[data-type="add-to-cart-form"]') || document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    const btnText = form.querySelector('.product-form__submit .btn__text');
    const baseLabel = btnText ? btnText.textContent.trim() : '';
    const qtyInput = document.querySelector('.product__info-wrapper input[name="quantity"]') || form.querySelector('input[name="quantity"]');
    let mainSubmit = false;
    form.addEventListener('submit', () => { mainSubmit = true; }, true);
    const priceEl = document.querySelector('[data-xp-price]');
    const unit = priceEl ? parseInt(priceEl.dataset.price, 10) : 0;
    const state = { pot: null, qty: 1, pct: 0 };

    // Direct kopen: zelfde toevoegactie als de hoofdknop (incl. gekozen pot), daarna door naar de kassa
    let direct = false;
    const submitBtn = form.querySelector('.product-form__submit');
    if (submitBtn && !form.parentElement.querySelector('.xp-direct')) {
      const d = document.createElement('button'); d.type = 'button'; d.className = 'xp-direct'; d.textContent = t('buy_now', 'Direct kopen');
      d.addEventListener('click', () => { direct = true; d.disabled = true; form.requestSubmit ? form.requestSubmit(submitBtn) : submitBtn.click(); setTimeout(() => { d.disabled = false; }, 6000); });
      form.after(d);
    }
    const naarKassa = () => { if (direct) { direct = false; window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout'; } };
    // Winkelwagen staat op "page" (settings cart_type): het thema verstuurt het formulier dan gewoon en
    // product-ajax:added komt nooit, dus de pot ging niet mee en Direct kopen ging naar /cart (fix 3 nov 2026).
    // Met een pot of Direct kopen voegen we daarom zelf plant (+ pot) toe en gaan dan naar winkelwagen of kassa.
    let bezig = false;
    form.addEventListener('submit', async (e) => {
      if (!state.pot && !direct) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (bezig) return;
      bezig = true;
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const fd = new FormData(form);
      if (!fd.get('quantity')) fd.set('quantity', String(state.qty || 1));
      try {
        const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
        if (!r.ok) { bezig = false; direct = false; HTMLFormElement.prototype.submit.call(form); return; }
        if (state.pot) {
          const rp = await fetch(root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: +state.pot.id, quantity: 1 }] })
          });
          if (!rp.ok) console.warn('pot toevoegen mislukt', rp.status);
        }
      } catch (err) { console.warn('toevoegen mislukt', err); }
      window.location.href = root + (direct ? 'checkout' : 'cart');
    }, true);
    let note = form.parentElement.querySelector('.xp-knopnoot');
    if (!note) { note = document.createElement('p'); note.className = 'xp-knopnoot'; note.hidden = true; form.after(note); }

    function render() {
      if (qtyInput) qtyInput.value = state.qty;
      const plant = unit * state.qty;
      const plantNa = Math.round(plant * (1 - state.pct / 100));
      const potPrijs = state.pot ? state.pot.combo : 0;
      const totaal = plantNa + potPrijs;
      if (btnText && !form.querySelector('.product-form__submit[disabled]')) {
        const wat = state.pot ? t('plant_pot', 'Plant + pot') : (state.qty > 1 ? state.qty + 'x' : '');
        btnText.textContent = baseLabel + ' · ' + (wat ? wat + ' ' : '') + fmt(totaal);
      }
      const bespaar = (plant - plantNa) + (state.pot ? state.pot.price - state.pot.combo : 0);
      note.hidden = bespaar <= 0;
      if (bespaar > 0) note.textContent = t('you_save', 'Je bespaart') + ' ' + fmt(bespaar);
      const uitleg = document.querySelector('[data-xp-staffel-uitleg]');
      if (uitleg) {
        uitleg.hidden = state.qty < 2;
        if (state.qty > 1) uitleg.textContent = state.qty + 'x ' + fmt(unit) + ' = ' + fmt(plantNa) + ' (' + t('discount_in_cart', 'korting zie je in de winkelwagen') + ')';
      }
    }

    function radio(container, selector, onPick) {
      container.querySelectorAll(selector).forEach((b) => b.addEventListener('click', () => {
        container.querySelectorAll(selector).forEach((x) => { x.classList.remove('is-actief'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-actief'); b.setAttribute('aria-checked', 'true'); onPick(b); render();
      }));
    }

    // Hoofdfoto wisselen naar "plant in deze pot" als daar een beeld van is.
    const hoofd = document.querySelector('.product__media-item img');
    const orig = hoofd ? { src: hoofd.getAttribute('src'), srcset: hoofd.getAttribute('srcset'), sizes: hoofd.getAttribute('sizes') } : null;
    function wissel(url) {
      if (!hoofd || !orig) return;
      if (url) { hoofd.removeAttribute('srcset'); hoofd.src = url + (url.includes('?') ? '&' : '?') + 'width=1400'; }
      else { hoofd.src = orig.src; if (orig.srcset) hoofd.setAttribute('srcset', orig.srcset); }
      const item = hoofd.closest('.product__media-item'); if (item && window.innerWidth >= 1024) item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
    const potBox = document.querySelector('[data-xp-pot]');
    if (potBox) radio(potBox, '.xp-potkaart', (b) => {
      wissel(b.dataset.xpPotImg || null);
      state.pot = b.dataset.xpPotId ? { id: b.dataset.xpPotId, price: +b.dataset.xpPotPrice, combo: +b.dataset.xpPotCombo, name: b.dataset.xpPotName } : null;
    });
    const stBox = document.querySelector('[data-xp-staffel]');
    if (stBox) radio(stBox, '.xp-staffelknop', (b) => { state.qty = +b.dataset.qty; state.pct = +b.dataset.pct; });

    // Na het toevoegen van de plant: gekozen pot erbij en winkelwagen verversen.
    document.addEventListener('product-ajax:added', async () => {
      if (!state.pot || !mainSubmit) { naarKassa(); return; }
      mainSubmit = false;
      try {
        await fetch((window.FoxTheme && FoxTheme.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +state.pot.id, quantity: 1 }] })
        });
        if (direct) { naarKassa(); return; }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      } catch (e) { console.warn('pot toevoegen mislukt', e); naarKassa(); }
    });

    render();
  }

  function panels() {
    // Buiten de sticky kolom plaatsen: een transform op een ouder breekt position:fixed.
    document.querySelectorAll('.xp-paneel, [data-xp-overlay]').forEach((el) => document.body.appendChild(el));
    const overlay = document.querySelector('[data-xp-overlay]');
    let open = null, last = null;
    const close = () => {
      if (!open) return;
      open.classList.remove('is-open');
      const p = open; setTimeout(() => { p.hidden = true; }, 280);
      overlay.hidden = true; document.body.classList.remove('xp-lock'); open = null;
      if (last) last.focus();
    };
    document.querySelectorAll('[data-xp-open]').forEach((b) => b.addEventListener('click', () => {
      const p = document.getElementById(b.dataset.xpOpen); if (!p) return;
      last = b; p.hidden = false; overlay.hidden = false; document.body.classList.add('xp-lock');
      requestAnimationFrame(() => p.classList.add('is-open'));
      open = p; const c = p.querySelector('[data-xp-close]'); if (c) c.focus();
    }));
    document.querySelectorAll('[data-xp-close]').forEach((b) => b.addEventListener('click', close));
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  // klein AR-logo linksonder op de eerste productfoto (alleen als het product een 3D-model heeft)
  function arLogo() {
    const sectie = document.querySelector('[data-xp3d]'); if (!sectie) return;
    const eerste = document.querySelector('media-gallery .product__media-item[data-media-index="0"] .product__media-item-container'); if (!eerste) return;
    const b = document.createElement('button'); b.type = 'button'; b.className = 'xp-ar-logo'; b.setAttribute('aria-label', sectie.dataset.arLabel || 'Bekijk in jouw ruimte');
    b.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7V4.5A1.5 1.5 0 0 1 4.5 3H7M17 3h2.5A1.5 1.5 0 0 1 21 4.5V7M21 17v2.5a1.5 1.5 0 0 1-1.5 1.5H17M7 21H4.5A1.5 1.5 0 0 1 3 19.5V17"/><path d="m12 7 4.5 2.5v5L12 17l-4.5-2.5v-5L12 7Z"/></svg><span>AR</span>';
    b.addEventListener('click', (e) => {
      e.preventDefault(); e.stopPropagation();
      const ar = sectie.querySelector('[data-shopify-xr]');
      if (ar && !ar.hasAttribute('data-shopify-xr-hidden')) { ar.click(); return; }
      if (window.xxl3dLaad) window.xxl3dLaad();
      sectie.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);
    eerste.appendChild(b);
  }

  // bloemfoto's: subtiele overlay dat de plant bij levering meestal nog niet bloeit (herkend aan '-bloem' in de bestandsnaam)
  function bloemNoot() {
    const tekst = t('bloom_note', 'Zo bloeit hij als volwassen plant. Bij levering meestal nog zonder bloem.');
    document.querySelectorAll('media-gallery .product__media-item').forEach((it) => {
      const img = it.querySelector('img'); if (!img || !/-bloem[-_.]/.test(img.currentSrc || img.src || '')) return;
      const c = it.querySelector('.product__media-item-container'); if (!c || c.querySelector('.xp-bloemnoot')) return;
      const n = document.createElement('p'); n.className = 'xp-bloemnoot'; n.textContent = tekst; c.appendChild(n);
    });
  }

  // sticky koopbalk alleen tonen als de koopknoppen bovenin uit beeld zijn
  function sticky() {
    const f = document.querySelector('.product__info-wrapper form[data-type="add-to-cart-form"]'); if (!f || !('IntersectionObserver' in window)) return;
    const doel = f.closest('.product__block') || f;
    new IntersectionObserver((e) => { document.documentElement.classList.toggle('xp-hoofd-in-beeld', e[0].isIntersecting || e[0].boundingClientRect.top > 0); }, { threshold: 0 }).observe(doel);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { [sticky, init, panels, arLogo, bloemNoot].forEach((f) => { try { f(); } catch (e) { console.warn('xxl-pdp', f.name, e); } }); });
  else { [sticky, init, panels, arLogo, bloemNoot].forEach((f) => { try { f(); } catch (e) { console.warn('xxl-pdp', f.name, e); } }); }
})();
